import { useQuery } from "@tanstack/react-query";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Link } from "wouter";

interface ProjectStats {
  total: number;
  active: number;
  completed: number;
  draft: number;
}

const statCards = [
  { label: "Projekte gesamt", key: "total" as const, href: "/dashboard" },
  { label: "In Bearbeitung",  key: "active" as const, href: "/dashboard" },
  { label: "Abgeschlossen",   key: "completed" as const, href: "/completed" },
];

export function ProjectStats() {
  const { data: stats, isLoading } = useQuery<ProjectStats>({
    queryKey: ["/api/projects/stats"],
  });

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {[...Array(3)].map((_, i) => (
          <Card key={i}>
            <CardContent className="p-6">
              <Skeleton className="h-4 w-24 mb-2" />
              <Skeleton className="h-8 w-16" />
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      {statCards.map(({ label, key, href }) => (
        <Link key={key} href={href}>
          <Card className="cursor-pointer transition-all duration-150 hover:shadow-md hover:border-bauwerk-teal hover:-translate-y-0.5">
            <CardContent className="p-6">
              <h3 className="text-bauwerk-teal font-medium mb-2">{label}</h3>
              <div className="text-3xl font-bold text-bauwerk-teal">
                {stats?.[key] ?? 0}
              </div>
            </CardContent>
          </Card>
        </Link>
      ))}
    </div>
  );
}
